import { EraQL, ExprVar, Ty } from '@cotera/era';
import { llm } from '@cotera/api';
import { ToolSymbolMap } from './types';
import { err, ok } from 'neverthrow';
import { v4 } from 'uuid';

const { c } = EraQL;

const modelTy = Ty.nn(Ty.enumOf(llm.LLM_MODELS));

export const agentSpecialForm =
  (params: { tools: ToolSymbolMap }): EraQL.SpecialForm =>
  (args, ctx, func) =>
    c
      .Args(
        c.StructOf({
          required: {
            messages: c.ListOf(
              c.StructOf({
                required: {
                  role: c.ExprOfTy(
                    Ty.nn(Ty.enumOf(['user', 'system', 'image', 'assistant']))
                  ),
                  content: c.ExprOfTy(Ty.nn('string')),
                },
                optional: {},
                strict: true,
              })
            ),
            model: c.ExprOfTy(modelTy),
            outputShape: LlmValidTy,
          },
          optional: {
            tools: c.ListOf(
              ValidTool({
                toolIds: new Set(
                  Object.values(params.tools).map((tool) => tool.toolId)
                ),
              })
            ),
            opts: c.StructOf({
              required: {},
              optional: {
                temperature: c.NumLit,
                // TODO: ...rest
              },
              strict: true,
            }),
          },
          strict: true,
        })
      )(args, ctx, func)
      .andThen(([opts]): EraQL.ParseRes<EraQL.CompileOutput> => {
        const { outputShape } = opts;

        // Placeholder of output value for type checking purposes
        const expr = ExprVar.create({
          name: v4(),
          scope: v4(),
          ty: outputShape.v[0],
        });

        return ok({
          item: { t: 'expr', expr },
          bindings: {},
        });
      });

const ValidTool =
  (params: { toolIds: Set<string> }): EraQL.c.ParseFunc<{ toolId: string }> =>
  (ast, ctx) =>
    c.Sp(ast, ctx).andThen((sp) => {
      const toolId = sp.meta?.['toolId'];

      if (!toolId || !params.toolIds.has(toolId)) {
        const e: EraQL.WithMeta<EraQL.ParseError> = [
          { t: 'expected', expected: 'tool' },
          ast[1],
        ];
        return err([e]);
      }

      return ok({ toolId });
    });

const LlmValidTy: EraQL.c.ParseFunc<Ty.ExtendedAttributeType> = (ast, ctx) =>
  c.Ty(ast, ctx).andThen((ty) => {
    // TODO
    const isValidLlmType = Math.random() > 0;

    if (isValidLlmType) {
      return ok(ty);
    } else {
      const e: EraQL.WithMeta<EraQL.ParseError> = [
        { t: 'custom', msg: `'${Ty.displayTy(ty)}' an invalid llm type yo!` },
        ast[1],
      ];

      return err([e]);
    }
  });
